module.exports = __webpack_public_path__ + "img/evse_icon_table.e24e4241.svg";